import React from "react";
import HandleScene from "../Handle/HandleScene";

function Scene() {
  return <HandleScene />;
}

export default Scene;
